import type { ReactNode } from 'react';
import { Icon, type IconName } from '../theme/Icon';
import { t } from '@app/i18n';
import s from './Badge.module.css';

export interface ChipProps {
  icon?: IconName;
  /** `true` = selecionado/ativo. */
  selected?: boolean;
  /** Quando presente, o chip ganha um botão de remover (filtro aplicado). */
  onRemove?: () => void;
  /** Rótulo do botão de remover. Padrão: "Remover {texto}". */
  removeLabel?: string;
  className?: string;
  children: ReactNode;
}

/** Chip (`.chip`) — rótulo neutro, filtro aplicado ou marca de contexto. */
export function Chip({ icon, selected, onRemove, removeLabel, className, children }: ChipProps) {
  return (
    <span
      className={[s.chip, selected ? s.chipOn : '', className].filter(Boolean).join(' ')}
      data-selected={selected ? 'true' : undefined}
    >
      {icon ? <Icon name={icon} size="xs" /> : null}
      {children}
      {onRemove ? (
        <button
          type="button"
          className={s.chipRemove}
          onClick={onRemove}
          aria-label={
            removeLabel ??
            t('common.ui.remove', {
              label: typeof children === 'string' ? children : t('common.ui.filter'),
            })
          }
        >
          <Icon name="close" size="xs" />
        </button>
      ) : null}
    </span>
  );
}
